import React from "react";
import Awardrecoorganishaward from '../components/Aboutus/Aboutaward';
import Banner from '../comman/Banner/Banner';



const Aboutrecoorgaward = () => {
    return (
        <>
            <Banner
                index={'about-4'}
            />
            <Awardrecoorganishaward />
        </>
    )
};
export default Aboutrecoorgaward;